// extracted by mini-css-extract-plugin
export default {"container":"SimeraCompanyScreen_container__r1KxV","content":"SimeraCompanyScreen_content__duCfT","spinnerContainer":"SimeraCompanyScreen_spinnerContainer__YoWzm"};